var _style, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedisLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_add73d4-1dc6-48f0-baac-87b2578a088c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132 88",
    style: {
      enableBackground: "new 0 0 132 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000080;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO_MEDIS_MOBILE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,57.1V42.2h2.4c1.6,0,1.8,2,1.8,2c0.9-1.4,2.3-2.3,4.1-2.3c2.2,0,3.5,1,4.2,2.4c1.1-1.4,2.7-2.4,4.7-2.4 c3.1,0,4.9,2.1,4.9,5.6v9.6h-4.3v-9.3c0-1.6-1.2-2.4-2.3-2.4c-1.2,0-2.3,0.8-2.3,2.6v9.2h-4.3v-9.4c0-1.5-1.1-2.3-2.2-2.3 c-1.2,0-2.3,0.8-2.4,2.3v9.3H56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.2,50.1c0-4.6-2-8.2-7-8.2c-4.6,0-7.4,3.5-7.4,7.7c0,4.6,3.2,7.8,7.6,7.8c3.4,0,5-1.1,6.6-3.2l-2.8-2 c-0.7,1.1-1.9,1.8-3.5,1.8c-1.7,0-3.2-0.9-3.5-3.4h10.2V50.1z M84.1,48c0.4-1.7,1.6-2.6,3-2.6c1.3,0,2.6,0.9,2.9,2.6H84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,55.2L106.3,55.2c-1.2,1.4-2.8,2.3-4.5,2.3c-4.2,0-6.4-3.8-6.4-7.8c0-4,2.3-7.7,6.5-7.7 c1.6,0,3.2,0.6,4.3,1.8v-8.9h4.3v22.3h-2.2C107.1,57.1,106.3,56.2,106.3,55.2z M106.2,49.6c0-2.3-1.3-3.9-3.3-3.9 c-2.2,0-3.3,1.8-3.3,4c0,2.2,1.1,4,3.3,4C104.8,53.6,106.2,51.7,106.2,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.9,35.1c1.3,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5c-1.3,0-2.5-1.1-2.5-2.5S113.6,35.1,114.9,35.1z  M112.7,57.1V42.2h1.8c1.4,0,2.5,1.1,2.5,2.5v12.4H112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9,52.1c1,1.2,2.7,1.7,4.1,1.7c0.9,0,1.6-0.4,1.6-0.9c0-0.8-0.8-1.1-2-1.5c-2.3-0.7-5.2-2-5.2-5 c0-2.9,2.8-4.5,5.3-4.5c2.3,0,3.8,0.8,5.2,2.2l-2.4,2.6c-0.6-0.7-1.8-1.3-2.7-1.3c-0.8,0-1.4,0.4-1.4,0.9c0,0.7,0.9,1.1,2.2,1.5 c2.3,0.7,5.2,2.1,5.2,4.9c0,2.8-2.4,4.8-5.8,4.8c-2.7,0-4.9-0.8-6.5-2.5L120.9,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,40.1L86.6,40.1l1.5-5.3h3.8c0,0-0.5,1.4-1.1,2.7C90,39.1,88.3,40.1,86.6,40.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 6.2646,
    cy: 81.6921,
    r: 54.1708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1147,
    style: {
      stopColor: "#000886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2911,
    style: {
      stopColor: "#001D96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    style: {
      stopColor: "#0040B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    style: {
      stopColor: "#0071D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A9FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.9,27C36.8,27,48,38.2,48,52.1S36.8,77.3,22.9,77.3V27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,32.4c0,6.6-4.3,10.6-8,12.6c-2.8,1.5-6.3,4.4-6.3,9.9l0,12.4h-7.4l0-13.2V23.3c0-7.9,9.5-11.9,15.2-6.4 c0,0,0.1,0.1,0.1,0.1C42.1,20.9,44.6,26.4,44.6,32.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 24.4314,
    cy: 56.6489,
    r: 43.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1147,
    style: {
      stopColor: "#000886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2911,
    style: {
      stopColor: "#001D96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    style: {
      stopColor: "#0040B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    style: {
      stopColor: "#0071D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A9FF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.9,67.3c-12.2,0-22.1-9.9-22.1-22.1s9.9-22.1,22.1-22.1V67.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 23.0916,
    cy: 62.0128,
    r: 51.3274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FFFAE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.7,35.4c-7.2,6.4-13.1,4.8-14.8,14.6V10.7c6,0,11.4,2.4,15.3,6.3C44.1,22.9,42.9,30.8,37.7,35.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,23.1v14.8c4.1,0,7.4-3.3,7.4-7.4C30.3,26.4,27,23.1,22.9,23.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,50L22.9,50c0-4.9-4-8.9-8.9-8.9H4.9V50v0.2H23V50H22.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedisLogoSvg);
export default __webpack_public_path__ + "static/media/medisLogoSvg.9b4f0873f568091f6ccd0935fd9df2cf.svg";
export { ForwardRef as ReactComponent };